export class OrientedHubSegment {
    get Segment() {
        return this.segment;
    }
    set Segment(value) {
        this.segment = value;
    }
    constructor(seg, reversed, index, bundleBase) {
        this.Segment = seg;
        this.Reversed = reversed;
        this.Index = index;
        this.BundleBase = bundleBase;
    }
    value(t) {
        return this.Reversed ? this.Segment.value(this.Segment.parEnd - t) : this.Segment.value(t);
    }
}
//# sourceMappingURL=OrientedHubSegment.js.map